import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import Loader from "../Loader";
import * as Yup from "yup";
import createCustomSchema from "../../fieldValidator/fieldValidator";
import { message } from "antd";
const RefereeDetailsModal = ({
  show,
  handleClose,
  handleSave,
  companyName,
  employee_id,
  referrer,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const referralSchema = Yup.object({
    name: createCustomSchema("text", {
      message: "*Please Enter Your Name!",
      min: 3,
    }),
    email: createCustomSchema("email", {
      message: "*Please Enter Your Email!",
    }),
    phone: createCustomSchema("phone", {
      message: "*Please Enter Your Phone Number!",
    }),
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const resetForm = () => {
    setFormData({ name: "", email: "", phone: "" });
    setErrors({});
  };

  const handleModalClose = () => {
    resetForm();
    handleClose();
  };

  const onSave = async () => {
    try {
      setLoading(true);
      setErrors({});
      await referralSchema.validate(formData, { abortEarly: false });
      await handleSave({
        ...formData,
        company_name: companyName,
        referrer: referrer,
        employee_id: employee_id,
      });
      handleModalClose();
    } catch (error) {
      if (error.name === "ValidationError") {
        const errorObj = {};
        error.inner.forEach((err) => {
          errorObj[err.path] = err.message;
        });
        setErrors(errorObj);
      } else {
        console.error("Error saving referral:", error);
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Modal show={show} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Referee Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="refereeName">
                  <Form.Label> Company Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    isInvalid={!!errors.name}
                    disabled={loading}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="refereeEmail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    isInvalid={!!errors.email}
                    disabled={loading}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.email}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group controlId="refereePhone">
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter phone number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    isInvalid={!!errors.phone}
                    disabled={loading}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.phone}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleModalClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={onSave} disabled={loading}>
            Refer
          </Button>
        </Modal.Footer>
      </Modal>
      <Loader show={loading} loadingMessage="" />
    </>
  );
};

export default RefereeDetailsModal;
